export const settings = {
  apiKey: "42148354-57d0-4317-b044-4d608b198539",
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
};
